/* ═══════════════════════════════════════════════════════════════
   OrgChartNoteService — read path for free-floating text-box notes on
   the org chart (migration 040, Josh grant 2026-08-17). List only:
   every write (create/move/edit/delete) rides the edit session's ONE
   `orgchart-commit` transaction (see OrgChartV2.tsx / commitOrgChart.ts)
   — mirrors OrgChartEdgeService/OrgChartJunctionService's read side,
   deliberately WITHOUT their save()/delete() (those are unused dead
   code on the other two services; not worth reintroducing here).
   ═══════════════════════════════════════════════════════════════ */

import * as cache from './cloudCache';
import type { OrgChartNote } from '../../shared/entities';

export const OrgChartNoteService = {
  list: async (): Promise<OrgChartNote[]> => cache.list<OrgChartNote>('org_chart_notes'),
};
